import { Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
  EntityStoreStateBase,
  StoreStatusState,
} from "../../../../shared/store/store-types.model";
import { Checklist } from "../../models/checklist.model";
import { ChecklistFacadeService } from "./checklist-facade.service";
import { Bundle } from "../../models/bundle.model";

@Injectable({ providedIn: "root" })
export class ChecklistStoreService extends EntityStoreService<
  Checklist,
  EntityMetadata,
  ChecklistState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
      currentBundle: null,
    });
  }
}

export interface ChecklistBaseState
  extends EntityStoreState<ChecklistFacadeService> {
  currentBundle: Bundle;
}

export type ChecklistState = ChecklistBaseState &
  StoreStatusState<ChecklistFacadeService> &
  EntityStoreStateBase;
